import { get } from "../../utils/api/api";
const pendingRequests = new Map();
const cache = new Map();
const CACHE_DURATION = 5000; 

export const getPlayerProfiles = async () => {
  const requestKey = "getPlayerProfiles";

  // Check cache first
  const cachedData = cache.get(requestKey);
  if (cachedData && Date.now() - cachedData.timestamp < CACHE_DURATION) {
    return cachedData.data;
  }

  // Check for pending request
  if (pendingRequests.has(requestKey)) {
    return pendingRequests.get(requestKey);
  }

  const request = get("player-profiles/stats");
  pendingRequests.set(requestKey, request);

  try {
    const result = await request;
    // Cache the result
    cache.set(requestKey, {
      data: result,
      timestamp: Date.now(),
    });
    return result;
  } finally {
    pendingRequests.delete(requestKey);
  }
};

export const getPlayerProfileById = async (id) => {
  const requestKey = `getPlayerProfileById-${id}`;

  // Check cache first
  const cachedData = cache.get(requestKey);
  if (cachedData && Date.now() - cachedData.timestamp < CACHE_DURATION) {
    return cachedData.data;
  }

  if (pendingRequests.has(requestKey)) {
    return pendingRequests.get(requestKey);
  }

  const request = get(`player-profiles/${id}`);
  pendingRequests.set(requestKey, request);

  try {
    const result = await request;
    // Cache the result
    cache.set(requestKey, {
      data: result,
      timestamp: Date.now(),
    });
    return result;
  } finally {
    pendingRequests.delete(requestKey);
  }
};

export const getPlayerProfileEntries = async (playerNumber) => {
  const requestKey = `getPlayerProfileEntries-${playerNumber}`;

  // Check cache first
  const cachedData = cache.get(requestKey);
  if (cachedData && Date.now() - cachedData.timestamp < CACHE_DURATION) {
    return cachedData.data;
  }

  if (pendingRequests.has(requestKey)) {
    return pendingRequests.get(requestKey);
  }

  const request = get(`player-profiles/entries/${playerNumber}`);
  pendingRequests.set(requestKey, request);

  try {
    const result = await request;
    // Cache the result
    cache.set(requestKey, {
      data: result,
      timestamp: Date.now(),
    });
    return result;
  } finally {
    pendingRequests.delete(requestKey);
  }
};

export const getDistinctPlayers = async (page, limit, search, startDate, endDate, sortKey, sortDirection) => {
  const searchTerm = search ? search.trim() : '';
  const requestKey = `getDistinctPlayers-${page}-${limit}-${searchTerm}-${startDate || ''}-${endDate || ''}-${sortKey}-${sortDirection}`;

  // Check cache first
  const cachedData = cache.get(requestKey);
  if (cachedData && Date.now() - cachedData.timestamp < CACHE_DURATION) {
    return cachedData.data;
  }

  if (pendingRequests.has(requestKey)) {
    return pendingRequests.get(requestKey);
  }

  const params = { 
    page: parseInt(page) || 1, 
    limit: parseInt(limit) || 10,
    sortField: sortKey || 'created_at',
    sortOrder: sortDirection || 'DESC'
  };
  
  if (searchTerm) {
    params.search = searchTerm;
  }
  
  if (startDate) {
    params.startDate = startDate;
  }
  
  if (endDate) {
    params.endDate = endDate;
  }

  const request = get("player-profiles/distinct", { params });
  pendingRequests.set(requestKey, request);

  try {
    const result = await request;
    cache.set(requestKey, {
      data: result,
      timestamp: Date.now(),
    });
    return result;
  } finally {
    pendingRequests.delete(requestKey);
  }
};

export const playerprofile = {
  getPlayerProfiles,
  getPlayerProfileById,
  getPlayerProfileEntries,
  getDistinctPlayers
};
